<ng-container>
    <div class="inside-container">
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <h3 class="tab-header" *ngIf="currentTool.data.name">{{ currentTool.data.name }}</h3>
            <h3 class="tab-header" *ngIf="!currentTool.data.name">
                <span
                    i18n="@@fb8c3bdc1fa9d7ab1f70d4e9e57046cbf11b0401"
                    t="fb8c3bdc1fa9d7ab1f70d4e9e57046cbf11b0401"
                    >Create New</span
                >
                {{ role }}
            </h3>
            <div>
                <button tsl-button (click)="closeView(false)" color="black" ghost>
                    <tsl-icon>keyboard_arrow_left</tsl-icon>
                    <span
                        i18n="@@f65253954b66e929a8b4d5ecaf61f9129f8cec64"
                        t="f65253954b66e929a8b4d5ecaf61f9129f8cec64"
                        >Dashboard</span
                    >
                </button>
                <button
                    tsl-button
                    size="small"
                    *ngIf="this.allowEdit"
                    (click)="openMismatchCommentBox()"
                    [disabled]="toolGroup.invalid || hasNoAssociatedParts"
                    i18n="@@Save"
                    t="Save"
                    >Save</button
                >
            </div>
        </div>

        <tsl-tab-group>
            <tsl-tab class="section-title" label="{{ role }} Details">
                <tsl-accordion [multiple]="true" [hideDivider]="false">
                    <tsl-accordion-group [expanded]="true">
                        <tsl-accordion-header>
                            <tsl-accordion-group-title
                                i18n-matTooltip
                                matTooltip="Click to expand/collapse"
                                i18n="@@037133c8fafeb336971f0ce39e9789407faf2b4d"
                                t="037133c8fafeb336971f0ce39e9789407faf2b4d"
                                >General Details</tsl-accordion-group-title
                            >
                        </tsl-accordion-header>
                        <div class="grid">
                            <div fxLayoutGap="20px">
                                <div fxFlex="75">
                                    <div [formGroup]="toolGroup" class="grid">
                                        <div fxLayoutGap="20px">
                                            <!-- Category -->
                                            <div fxFlex="50">
                                                <tsl-form-field fxFlex="100">
                                                    <tsl-label for="category"
                                                        >{{ role }}
                                                        <span i18n="@@Category" t="Category">Category</span>
                                                    </tsl-label>
                                                    <tsl-select
                                                        id="category"
                                                        required
                                                        fullWidth
                                                        formControlName="toolCategory"
                                                        (selectionChange)="onChangeCategory($event)"
                                                    >
                                                        <tsl-option
                                                            *ngFor="let cat of filterCategories"
                                                            [value]="cat.id"
                                                            >{{ translate.get(cat.category) }}</tsl-option
                                                        >
                                                    </tsl-select>
                                                    <tsl-error
                                                        *ngIf="toolCategory.invalid"
                                                        i18n="@@Required"
                                                        t="Required"
                                                        >Required</tsl-error
                                                    >
                                                </tsl-form-field>
                                            </div>

                                            <!-- Subcategory -->
                                            <div fxFlex="50">
                                                <tsl-form-field fxFlex="100">
                                                    <tsl-label for="subcategory">{{ role }} Sub-Category</tsl-label>
                                                    <tsl-select
                                                        id="subcategory"
                                                        required
                                                        fullWidth
                                                        formControlName="toolSubcategory"
                                                        (selectionChange)="onChangeSubcategory($event)"
                                                        [disabled]="!hastoolCategory"
                                                    >
                                                        <tsl-option
                                                            *ngFor="let sub of filterSubcategories"
                                                            [value]="sub.id"
                                                            >{{ translate.get(sub.subcategory) }}</tsl-option
                                                        >
                                                    </tsl-select>
                                                    <tsl-error
                                                        *ngIf="toolSubcategory.invalid"
                                                        i18n="@@Required"
                                                        t="Required"
                                                        >Required</tsl-error
                                                    >
                                                </tsl-form-field>
                                            </div>
                                        </div>

                                        <div fxLayoutGap="20px">
                                            <!-- Name -->
                                            <div fxFlex="50">
                                                <tsl-form-field fxFlex="100">
                                                    <tsl-label for="name"
                                                        >{{ role }}
                                                        <span
                                                            i18n="@@cff1428d10d59d14e45edec3c735a27b5482db59"
                                                            t="cff1428d10d59d14e45edec3c735a27b5482db59"
                                                            >Name</span
                                                        >
                                                    </tsl-label>
                                                    <input
                                                        id="name"
                                                        tslInput
                                                        required
                                                        fullWidth
                                                        maxlength="50"
                                                        formControlName="name"
                                                    />
                                                    <tsl-error
                                                        *ngIf="name.invalid && name.errors && name.errors.required"
                                                        i18n="@@Required"
                                                        t="Required"
                                                        >Required</tsl-error
                                                    >
                                                    <tsl-error
                                                        *ngIf="
                                                            name.errors && !name.errors.required && name.errors.pattern
                                                        "
                                                    >
                                                        <span i18n="@@208181588292540046" t="208181588292540046"
                                                            >Only alphanumeric, underscore, space, hyphen, single quote,
                                                            :, . characters allowed</span
                                                        >
                                                    </tsl-error>
                                                </tsl-form-field>
                                            </div>

                                            <!-- Identifier -->
                                            <div fxFlex="50">
                                                <tsl-form-field fxFlex="100">
                                                    <tsl-label for="identifier"
                                                        >{{ role }}
                                                        <span
                                                            i18n="@@4e2591df099ddac796cda401c5f282da779d45f2"
                                                            t="4e2591df099ddac796cda401c5f282da779d45f2"
                                                            >Identifier</span
                                                        >
                                                    </tsl-label>
                                                    <input
                                                        id="identifier"
                                                        tslInput
                                                        fullWidth
                                                        maxlength="50"
                                                        formControlName="identifier"
                                                    />
                                                    <tsl-error *ngIf="identifier.errors && identifier.errors.pattern">
                                                        <span i18n="@@208181588292540046" t="208181588292540046"
                                                            >Only alphanumeric, underscore, space, hyphen, single quote,
                                                            :, . characters allowed</span
                                                        >
                                                    </tsl-error>
                                                </tsl-form-field>
                                            </div>
                                        </div>

                                        <div fxLayoutGap="20px">
                                            <!-- Quantity -->
                                            <div fxFlex="50">
                                                <tsl-form-field fxFlex="100">
                                                    <tsl-label for="qty">
                                                        <span
                                                            i18n="@@6a6fb741e4aa441a66225c826e88210ae46e0999"
                                                            t="6a6fb741e4aa441a66225c826e88210ae46e0999"
                                                            >Number of</span
                                                        >
                                                        {{ role }}s
                                                    </tsl-label>
                                                    <input
                                                        id="qty"
                                                        tslInput
                                                        fullWidth
                                                        max="100000"
                                                        type="number"
                                                        formControlName="quantity"
                                                    />
                                                </tsl-form-field>
                                            </div>

                                            <!-- Is Expendable -->
                                            <div fxFlex="50">
                                                <tsl-form-field fxFlex="100">
                                                    <tsl-label for="isExpendable"
                                                        ><span
                                                            i18n="@@7fd2060dca3e3621d6eeb5643d65be689b30980f"
                                                            t="7fd2060dca3e3621d6eeb5643d65be689b30980f"
                                                            >Expendable</span
                                                        ><tsl-icon
                                                            class="header-help-icon"
                                                            tslPopoverPosition="after"
                                                            tslPopoverTrigger="hover"
                                                            tslPopover="Does the Tool have a limited life?"
                                                            size="small"
                                                            >info</tsl-icon
                                                        ></tsl-label
                                                    >
                                                    <tsl-select
                                                        id="isExpendable"
                                                        fullWidth
                                                        formControlName="isExpendable"
                                                    >
                                                        <tsl-option [value]="true" i18n="@@Yes" t="Yes"
                                                            >Yes</tsl-option
                                                        >
                                                        <tsl-option [value]="false" i18n="@@No" t="No"
                                                            >No</tsl-option
                                                        >
                                                    </tsl-select>
                                                    <div
                                                        class="tsl-error"
                                                        *ngIf="this.toolGroup.errors?.expendableInvalid"
                                                        i18n="@@83a2dc2e466dd974f97dcdcd1c7755ff483059d4"
                                                        t="83a2dc2e466dd974f97dcdcd1c7755ff483059d4"
                                                        >Expiration Date or Number of Parts field is required</div
                                                    >
                                                </tsl-form-field>
                                            </div>
                                        </div>

                                        <div *ngIf="this.toolGroup" fxLayoutGap="20px">
                                            <div fxFlex="50"> </div>
                                            <div fxFlex="50" fxLayoutGap="20px">
                                                <!-- Expiration Date -->
                                                <div fxFlex="50" *ngIf="this.toolGroup && this.isExpendable.value">
                                                    <tsl-form-field fxFlex="100">
                                                        <tsl-label
                                                            i18n="@@41d055ec9cef3afb116c3118c2244ee66c895fbb"
                                                            t="41d055ec9cef3afb116c3118c2244ee66c895fbb"
                                                            >Expiration Date</tsl-label
                                                        >
                                                        <tsl-datepicker
                                                            singleSelection
                                                            formControlName="expirationDate"
                                                            [readonly]="true"
                                                        >
                                                        </tsl-datepicker>
                                                    </tsl-form-field>
                                                </div>

                                                <!-- No of parts until expiration -->
                                                <div fxFlex="50" *ngIf="this.toolGroup && this.isExpendable.value">
                                                    <tsl-form-field fxFlex="100">
                                                        <tsl-label
                                                            for="numberOfParts"
                                                            i18n="@@db952590f75d49d248a20096c4211fccee20510a"
                                                            t="db952590f75d49d248a20096c4211fccee20510a"
                                                            >Number of parts until expiration</tsl-label
                                                        >
                                                        <input
                                                            id="numberOfParts"
                                                            tslInput
                                                            fullWidth
                                                            max="100000"
                                                            min="1"
                                                            type="number"
                                                            formControlName="numberOfParts"
                                                        />
                                                    </tsl-form-field>
                                                </div>
                                            </div>
                                        </div>

                                        <div fxLayoutGap="20px">
                                            <!-- Location -->
                                            <div fxFlex="50">
                                                <tsl-form-field fxFlex="100">
                                                    <tsl-label for="location"
                                                        ><span
                                                            i18n="@@ed31c09fd77c36238c13d83635f3fe5294c733d2"
                                                            t="ed31c09fd77c36238c13d83635f3fe5294c733d2"
                                                            >Location</span
                                                        ><tsl-icon
                                                            class="header-help-icon"
                                                            tslPopoverPosition="after"
                                                            tslPopoverTrigger="hover"
                                                            tslPopover="Please select a location, if location not present, navigate to address tab to create manufacturing location"
                                                            size="small"
                                                            style="padding-left: 0px;"
                                                            >info</tsl-icon
                                                        ></tsl-label
                                                    >
                                                    <input
                                                        id="location"
                                                        required
                                                        tslInput
                                                        fullWidth
                                                        formControlName="location"
                                                        [tslAutocomplete]="locationAuto"
                                                    />
                                                    <tsl-autocomplete
                                                        #locationAuto="tslAutocomplete"
                                                        contentWidth="content"
                                                        [displayWith]="locationAutoDisplay"
                                                        (optionSelected)="onSelectLocation($event.option)"
                                                    >
                                                        <tsl-option
                                                            *ngFor="let item of locationsFiltered$ | async"
                                                            [value]="item"
                                                        >
                                                            {{ locationAutoDisplay(item) }}
                                                        </tsl-option>
                                                    </tsl-autocomplete>
                                                    <tsl-error
                                                        *ngIf="hasIncorrectAddress"
                                                        i18n="@@141724341849920609"
                                                        t="141724341849920609"
                                                        >Please Enter Valid Address</tsl-error
                                                    >
                                                </tsl-form-field>
                                            </div>

                                            <!-- Status -->
                                            <div fxFlex="50">
                                                <tsl-form-field fxFlex="100">
                                                    <tsl-label for="status"
                                                        >{{ role }}
                                                        <ng-container>
                                                            <span i18n="@@Status" t="Status">Status</span>
                                                            <tsl-icon
                                                                class="header-help-icon"
                                                                tslPopoverPosition="after"
                                                                tslPopoverTrigger="hover"
                                                                [tslPopover]="statusHelpContent"
                                                                size="small"
                                                                style="padding-left: 0px;"
                                                                >info</tsl-icon
                                                            >
                                                        </ng-container>
                                                    </tsl-label>
                                                    <tsl-select id="status" required fullWidth formControlName="status">
                                                        <tsl-option
                                                            [value]="'active'"
                                                            i18n="@@b36e1450940b7f6028d8587568c7d669b53f7a06"
                                                            t="b36e1450940b7f6028d8587568c7d669b53f7a06"
                                                            >Active</tsl-option
                                                        >
                                                        <tsl-option
                                                            [value]="'future'"
                                                            i18n="@@18a5dd7f62a3e97a4df965ffbdb11cce448b41c0"
                                                            t="18a5dd7f62a3e97a4df965ffbdb11cce448b41c0"
                                                            >Future</tsl-option
                                                        >
                                                        <tsl-option
                                                            [value]="'notactive'"
                                                            i18n="@@6f44e5ac01cb0823e4b621f777cad31aac81bff6"
                                                            t="6f44e5ac01cb0823e4b621f777cad31aac81bff6"
                                                            >Not Active
                                                        </tsl-option>
                                                        <tsl-option
                                                            [value]="'service'"
                                                            i18n="@@d473e0f684a60db45d6f31e993f693f74290e056"
                                                            t="d473e0f684a60db45d6f31e993f693f74290e056"
                                                            >Service</tsl-option
                                                        >
                                                    </tsl-select>
                                                    <tsl-error
                                                        *ngIf="status.invalid"
                                                        i18n="@@Required"
                                                        t="Required"
                                                        >Required</tsl-error
                                                    >
                                                </tsl-form-field>
                                                <button
                                                    tsl-icon-button
                                                    (click)="getMismatchOverrideComment()"
                                                    *ngIf="hasOverrideComment"
                                                    style="height:72px;"
                                                >
                                                    <tsl-icon status="primary">info</tsl-icon>
                                                </button>
                                            </div>
                                        </div>
                                        <div fxLayoutGap="20px">
                                            <!-- Asset? -->
                                            <div fxFlex="50">
                                                <tsl-form-field fxFlex="100">
                                                    <tsl-label for="isTeslaAsset">
                                                        <span
                                                            i18n="@@b68eb907ff32f6c73e31c917df28387737859e56"
                                                            t="b68eb907ff32f6c73e31c917df28387737859e56"
                                                            >Tesla Asset?</span
                                                        >
                                                        <tsl-icon
                                                            class="header-help-icon"
                                                            tslPopoverPosition="after"
                                                            tslPopoverTrigger="hover"
                                                            tslPopover="Is the Tool associated with a Tesla tooling Asset?"
                                                            size="small"
                                                            style="padding-left: 0px;"
                                                            >info</tsl-icon
                                                        >
                                                    </tsl-label>
                                                    <tsl-select
                                                        id="isTeslaAsset"
                                                        required
                                                        fullWidth
                                                        formControlName="isTeslaAsset"
                                                        (selectionChange)="onIsTeslaAsset()"
                                                    >
                                                        <tsl-option [value]="true" i18n="@@Yes" t="Yes"
                                                            >Yes</tsl-option
                                                        >
                                                        <tsl-option [value]="false" i18n="@@No" t="No"
                                                            >No</tsl-option
                                                        >
                                                    </tsl-select>
                                                    <tsl-error
                                                        *ngIf="isTeslaAsset.invalid"
                                                        i18n="@@Required"
                                                        t="Required"
                                                        >Required</tsl-error
                                                    >
                                                </tsl-form-field>
                                            </div>
                                            <div fxFlex="50"> </div>
                                        </div>
                                        <div fxLayoutGap="20px">
                                            <!-- Asset Number -->
                                            <div fxFlex="50" *ngIf="this.toolGroup && this.isTeslaAsset.value">
                                                <div class="label" *ngIf="!isAssetTagNumberAdding">
                                                    <tsl-label
                                                        ><span
                                                            i18n="@@fcd8accd435979359c4e5cdf789d5971ac710435"
                                                            t="fcd8accd435979359c4e5cdf789d5971ac710435"
                                                            >Asset Tag Number</span
                                                        >*</tsl-label
                                                    >
                                                    <button
                                                        tsl-icon-button
                                                        i18n-matTooltip
                                                        matTooltip="Add Asset"
                                                        (click)="onAssetTagNumerAdding()"
                                                        *ngIf="this.allowEdit"
                                                    >
                                                        <tsl-icon status="primary">add</tsl-icon>
                                                    </button>
                                                </div>
                                                <div *ngIf="isAssetTagNumberAdding">
                                                    <tsl-form-field fxFlex="100">
                                                        <tsl-label
                                                            for="assetNumber"
                                                            i18n="@@fcd8accd435979359c4e5cdf789d5971ac710435"
                                                            t="fcd8accd435979359c4e5cdf789d5971ac710435"
                                                            >Asset Tag Number</tsl-label
                                                        >
                                                        <input
                                                            id="assetNumber"
                                                            tslInput
                                                            fullWidth
                                                            maxlength="50"
                                                            autocomplete="off"
                                                            formControlName="assetTagNumber"
                                                            [tslAutocomplete]="assetNumber"
                                                        />
                                                        <tsl-autocomplete
                                                            #assetNumber="tslAutocomplete"
                                                            [displayWith]="assetAutoDisplay"
                                                            (optionSelected)="onSelectAsset($event.option)"
                                                        >
                                                            <tsl-option
                                                                *ngFor="let asset of assetsFiltered$ | async"
                                                                [value]="asset"
                                                                >{{ asset.assetCode }} -
                                                                {{ asset.assetDescription }}</tsl-option
                                                            >
                                                        </tsl-autocomplete>
                                                        <tsl-error
                                                            *ngIf="assets.invalid"
                                                            i18n="@@Required"
                                                            t="Required"
                                                            >Required</tsl-error
                                                        >
                                                    </tsl-form-field>
                                                </div>
                                                <div>
                                                    <div fxFlex="100">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th
                                                                        i18n="
                                                                            @@fcd8accd435979359c4e5cdf789d5971ac710435
                                                                        "
                                                                        t="fcd8accd435979359c4e5cdf789d5971ac710435"
                                                                        >Asset Tag Number
                                                                    </th>
                                                                    <th>
                                                                        <span i18n="@@Status" t="Status"
                                                                            >Status</span
                                                                        >*
                                                                        <tsl-icon
                                                                            class="header-help-icon"
                                                                            tslPopoverPosition="after"
                                                                            tslPopoverTrigger="hover"
                                                                            [tslPopover]="assetStatusHelpContent"
                                                                            size="small"
                                                                            >info</tsl-icon
                                                                        >
                                                                    </th>
                                                                    <th i18n="@@Action" t="Action">Action </th>
                                                                    <th
                                                                        *ngIf="showCMTChanges == 1"
                                                                        i18n="@@CMT#"
                                                                        t="CMT#"
                                                                        >CMT#
                                                                    </th>
                                                                    <th
                                                                        *ngIf="showCMTChanges == 1"
                                                                        i18n="@@CMTStatus"
                                                                        t="CMTStatus"
                                                                        >CMT Status
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody formArrayName="assets">
                                                                <tr
                                                                    *ngFor="
                                                                        let asset of assets['controls'];
                                                                        let i = index
                                                                    "
                                                                    [formGroupName]="i"
                                                                >
                                                                    <td
                                                                        ><strong>{{
                                                                            asset.get('assetCode').value
                                                                        }}</strong></td
                                                                    >
                                                                    <td style="padding-top: 5px;">
                                                                        <tsl-select
                                                                            id="AssetStatus"
                                                                            formControlName="assetStatus"
                                                                            (selectionChange)="
                                                                                onSelectAssetStatus(asset, $event)
                                                                            "
                                                                            required
                                                                            fullWidth
                                                                        >
                                                                            <tsl-option
                                                                                [value]="''"
                                                                                i18n="
                                                                                    @@0638eb541b1e51efffced7756e98a9e90bfa3139
                                                                                "
                                                                                t="0638eb541b1e51efffced7756e98a9e90bfa3139"
                                                                                >Select</tsl-option
                                                                            >
                                                                            <tsl-option
                                                                                [value]="'active'"
                                                                                [disabled]="isActiveDisabled(asset)"
                                                                                i18n="
                                                                                    @@6935511f78371a6514b0c5d92917036684ca2446
                                                                                "
                                                                                t="6935511f78371a6514b0c5d92917036684ca2446"
                                                                                >Active
                                                                            </tsl-option>
                                                                            <tsl-option
                                                                                [value]="'future'"
                                                                                [disabled]="isFutureDisabled(asset)"
                                                                                i18n="
                                                                                    @@1fee5f41c43407fb8addabb47e0876201288d7be
                                                                                "
                                                                                t="1fee5f41c43407fb8addabb47e0876201288d7be"
                                                                                >Future
                                                                            </tsl-option>
                                                                            <tsl-option
                                                                                [value]="'service'"
                                                                                [disabled]="isServiceDisabled(asset)"
                                                                                i18n="
                                                                                    @@b65d41005bc50270f09d9f13a492be42dba55b69
                                                                                "
                                                                                t="b65d41005bc50270f09d9f13a492be42dba55b69"
                                                                                >Service
                                                                            </tsl-option>
                                                                            <tsl-option
                                                                                [value]="'notactive'"
                                                                                [disabled]="isInactiveDisabled(asset)"
                                                                                i18n="
                                                                                    @@6f44e5ac01cb0823e4b621f777cad31aac81bff6
                                                                                "
                                                                                t="6f44e5ac01cb0823e4b621f777cad31aac81bff6"
                                                                                >Not Active
                                                                            </tsl-option>
                                                                        </tsl-select>
                                                                    </td>
                                                                    <td>
                                                                        <button
                                                                            tsl-icon-button
                                                                            i18n-matTooltip
                                                                            matTooltip="Delete"
                                                                            (click)="
                                                                                onRemoveAsset(
                                                                                    asset.get('assetCode').value,
                                                                                    i
                                                                                )
                                                                            "
                                                                            *ngIf="i > this.savedAssets - 1"
                                                                        >
                                                                            <tsl-icon status="primary">delete</tsl-icon>
                                                                        </button>
                                                                    </td>
                                                                    <td *ngIf="showCMTChanges == 1"
                                                                        ><strong
                                                                            ><a
                                                                                [href]="
                                                                                    getcmtUrl(
                                                                                        asset.get('assetCode').value
                                                                                    )
                                                                                "
                                                                                [target]="_blank"
                                                                                >{{
                                                                                    getCMTNumber(
                                                                                        asset.get('assetCode').value
                                                                                    )
                                                                                }}</a
                                                                            ></strong
                                                                        >
                                                                    </td>
                                                                    <td *ngIf="showCMTChanges == 1">
                                                                        <strong>{{
                                                                            getCMTStatus(asset.get('assetCode').value)
                                                                        }}</strong>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div fxFlex="50"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </tsl-accordion-group>

                    <tsl-accordion-group [expanded]="true">
                        <tsl-accordion-header>
                            <tsl-accordion-group-title
                                i18n-matTooltip
                                matTooltip="Click to expand/collapse"
                                i18n="@@c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b"
                                t="c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b"
                                >Characteristic</tsl-accordion-group-title
                            >
                        </tsl-accordion-header>

                        <div>
                            <div fxFlex="65%">
                                <div>
                                    <button
                                        tsl-icon-button
                                        i18n-matTooltip
                                        matTooltip="Add Characteristic"
                                        (click)="onAddParam()"
                                        *ngIf="this.allowEdit && this.toolSubcategory?.value"
                                    >
                                        <tsl-icon status="primary">add</tsl-icon>
                                    </button>
                                </div>
                                <table class="parameters">
                                    <thead>
                                        <tr>
                                            <th
                                                i18n="@@c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b"
                                                t="c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b"
                                                >Characteristic</th
                                            >
                                            <th
                                                i18n="@@5049e204c14c648691ac775a64fb504467aeb549"
                                                t="5049e204c14c648691ac775a64fb504467aeb549"
                                                >Value</th
                                            >
                                            <th i18n="@@Actions" t="Actions">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let param of parametersData; index as i">
                                            <td>{{ param.typeName }}</td>
                                            <td>
                                                {{ param.value }}
                                            </td>
                                            <td>
                                                <button
                                                    tsl-icon-button
                                                    i18n-matTooltip
                                                    matTooltip="Edit"
                                                    (click)="onEditParam(param)"
                                                    *ngIf="this.allowEdit"
                                                >
                                                    <tsl-icon status="primary">edit</tsl-icon>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </tsl-accordion-group>
                    <tsl-accordion-group [expanded]="true">
                        <tsl-accordion-header>
                            <tsl-accordion-group-title
                                i18n-matTooltip
                                matTooltip="Click to expand/collapse"
                                i18n="@@fdaace3b87747f2d7380af30f5d54ddc49680272"
                                t="fdaace3b87747f2d7380af30f5d54ddc49680272"
                                >Attachments</tsl-accordion-group-title
                            >
                        </tsl-accordion-header>
                        <div fxFlex="25" class="attachments">
                            <label
                                class="label"
                                i18n="@@c10801eb3a0f54ba6d4e5effc74f8264a6be43ea"
                                t="c10801eb3a0f54ba6d4e5effc74f8264a6be43ea"
                                >Asset Tag Number Pictures:</label
                            >
                            <tsl-file-drop
                                [inputText]="translate.get('choose a file')" [hintText]="translate.get('Drag and Drop a File or ')"
                                #tagFileDrop
                                accept=".png,.jpeg,.gif,.jpg,.bmp"
                                height="35px"
                                (fileChange)="onTagFileAdd($event)"
                                *ngIf="this.allowEdit"
                            >
                            </tsl-file-drop>
                            <div style="height: 100px;">
                                <div class="image-list">
                                    <ul>
                                        <li *ngFor="let file of currentTool.data.tagAttachment; index as i">
                                            <div
                                                class="file-img {{ getFileType(file) }}"
                                                matTooltip="{{ file.name }}"
                                                (click)="onDownloadFile(file)"
                                            ></div>
                                            <tsl-icon (click)="onTagFileDelete(file, i)" *ngIf="this.allowEdit"
                                                >delete</tsl-icon
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div fxFlex="30%" class="attachments" style="padding-left: 20px;">
                            <div
                                i18n="@@55a06b6ac8f50eba6b96354e61e3b9e308b972b6"
                                t="55a06b6ac8f50eba6b96354e61e3b9e308b972b6"
                                >Asset Pictures:</div
                            >
                            <tsl-file-drop
                                [inputText]="translate.get('choose a file')" [hintText]="translate.get('Drag and Drop a File or ')"
                                #assetFileDrop
                                accept=".png,.jpeg,.gif,.jpg,.bmp"
                                height="35px"
                                (fileChange)="onAssetFileAdd($event)"
                                *ngIf="this.allowEdit"
                            >
                            </tsl-file-drop>
                            <div style="height: 100px;">
                                <div class="image-list">
                                    <ul>
                                        <li *ngFor="let file of currentTool.data.assetAttachment; index as i">
                                            <div
                                                class="file-img {{ getFileType(file) }}"
                                                matTooltip="{{ file.name }}"
                                                (click)="onDownloadFile(file)"
                                            ></div>
                                            <tsl-icon
                                                size="small"
                                                (click)="onAssetFileDelete(file, i)"
                                                *ngIf="this.allowEdit"
                                                >delete
                                            </tsl-icon>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </tsl-accordion-group>
                </tsl-accordion>
            </tsl-tab>

            <tsl-tab label="Deliverables">
                <div class="mat-elevation-z2">
                    <div class="right-container">
                        <button
                            tsl-button
                            outline
                            size="small"
                            color="black"
                            (click)="openReOrderDialog()"
                            *ngIf="this.userDetails.isTeslaUser"
                            [disabled]="toolSubcategory.invalid"
                            i18n="@@Re-order"
                            t="Re-order"
                            >Re-order</button
                        >
                        <button
                            tsl-button
                            outline
                            size="small"
                            color="black"
                            (click)="onAddEvent(-1)"
                            *ngIf="this.allowEdit"
                            [disabled]="toolSubcategory.invalid"
                            i18n="@@bb4d8dd6bb36ac10d2e4419c23f76598ace2db40"
                            t="bb4d8dd6bb36ac10d2e4419c23f76598ace2db40"
                            >Add Deliverable</button
                        >
                    </div>
                    <table tsl-table [dataSource]="deliverablesData" class="deliverables">
                        <ng-container tslColumnDef="event">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@a20835f355331a7398ce79b54cff3c57e96b3c75"
                                t="a20835f355331a7398ce79b54cff3c57e96b3c75"
                                >Event</th
                            >
                            <td tsl-cell *tslCellDef="let deli"> &nbsp; </td>
                        </ng-container>

                        <ng-container tslColumnDef="deliverable">
                            <th tsl-header-cell *tslHeaderCellDef i18n="@@Deliverable" t="Deliverable"
                                >Deliverable</th
                            >
                            <td tsl-cell *tslCellDef="let deli"> {{ deli.deliverable }} </td>
                        </ng-container>

                        <ng-container tslColumnDef="startDate">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@3e6acd589d8b82cafd8546409da0a36469d297a0"
                                t="3e6acd589d8b82cafd8546409da0a36469d297a0"
                                >Start Date</th
                            >
                            <td tsl-cell *tslCellDef="let deli"> {{ deli.startDate | date }} </td>
                        </ng-container>

                        <ng-container tslColumnDef="plannedDate">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@4d961692683b8c12d806cc44691277aeeade42e5"
                                t="4d961692683b8c12d806cc44691277aeeade42e5"
                                >Planned Date</th
                            >
                            <td tsl-cell *tslCellDef="let deli"> {{ deli.plannedDate | date }} </td>
                        </ng-container>

                        <ng-container tslColumnDef="actualDate">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@363815f9ef9291da0b2a6f2a9322751e0d9dbaf6"
                                t="363815f9ef9291da0b2a6f2a9322751e0d9dbaf6"
                                >Actual Date</th
                            >
                            <td tsl-cell *tslCellDef="let deli"> {{ deli.actualDate | date }} </td>
                        </ng-container>

                        <ng-container tslColumnDef="files">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@18841af4ea428c2de9a8817a240d22d16d8cbf0d"
                                t="18841af4ea428c2de9a8817a240d22d16d8cbf0d"
                                >Files</th
                            >
                            <td tsl-cell *tslCellDef="let deli">
                                <div class="file-list">
                                    <ul>
                                        <li *ngFor="let file of deli.attachments; index as j">
                                            <a
                                                class="small"
                                                (click)="onDownloadFile(file)"
                                                matTooltip="{{ file.name }}"
                                            >
                                                <tsl-icon status="primary">download</tsl-icon>
                                                {{ file.name }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container tslColumnDef="submissionInfo">
                            <th tsl-header-cell *tslHeaderCellDef i18n="@@SubmissionInfo" t="SubmissionInfo"
                                >Submission Info</th
                            >
                            <td tsl-cell *tslCellDef="let deli">
                                <button
                                    *ngIf="deli.supplierComment !== null && deli.supplierComment !== undefined"
                                    tsl-icon-button
                                    (click)="openSupplierComment(deli.submitter, deli.submitDate, deli.supplierComment)"
                                >
                                    <tsl-icon>visibilityon</tsl-icon>
                                </button>
                            </td>
                        </ng-container>

                        <ng-container tslColumnDef="reviewInfo">
                            <th tsl-header-cell *tslHeaderCellDef i18n="@@ReviewInfo" t="ReviewInfo"
                                >Review Info</th
                            >
                            <td tsl-cell *tslCellDef="let deli">
                                <button
                                    *ngIf="deli.approvalComment !== null && deli.approvalComment !== undefined"
                                    tsl-icon-button
                                    (click)="openReviewComment(deli.approver, deli.approvalDate, deli.approvalComment)"
                                >
                                    <tsl-icon>visibilityon</tsl-icon>
                                </button>
                            </td>
                        </ng-container>

                        <ng-container tslColumnDef="status">
                            <th tsl-header-cell *tslHeaderCellDef i18n="@@Status" t="Status">Status</th>
                            <td tsl-cell *tslCellDef="let deli">
                                <span [ngClass]="getStatusColor(deli.status)">{{ getStatus(deli.status) }}</span>
                            </td>
                        </ng-container>

                        <ng-container tslColumnDef="actions">
                            <th tsl-header-cell *tslHeaderCellDef i18n="@@Actions" t="Actions">Actions</th>
                            <td tsl-cell *tslCellDef="let deli">
                                <button
                                    tsl-icon-button
                                    (click)="onEditDeliverable(deli.eventType, deli)"
                                    *ngIf="editOn(deli.status)"
                                >
                                    <tsl-icon status="primary">edit</tsl-icon>
                                </button>
                                <button
                                    tsl-icon-button
                                    (click)="onRemoveDeliverable(deli)"
                                    *ngIf="deleteOn(deli.status, deli.isDefault, deli.isCreatedByTeslaUser)"
                                >
                                    <tsl-icon status="error">delete</tsl-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr tsl-header-row *tslHeaderRowDef="deliverableColumns"></tr>
                        <tr tsl-row *tslRowDef="let row; columns: deliverableColumns"></tr>

                        <!-- Group header -->
                        <ng-container tslColumnDef="groupHeader">
                            <td colspan="7" tsl-cell *tslCellDef="let group">
                                <strong class="group-header">{{ group.name }}</strong>
                            </td>
                        </ng-container>
                        <tr tsl-row *tslRowDef="let row; columns: ['groupHeader']; when: isDeliverableHeader"> </tr>
                    </table>
                </div>
            </tsl-tab>

            <tsl-tab label="Associated Parts*">
                <div class="mat-elevation-z2">
                    <div class="right-container">
                        <button
                            tsl-button
                            outline
                            size="small"
                            color="black"
                            (click)="openAssociatedPartsDialog()"
                            *ngIf="this.allowEdit"
                            i18n="@@7d67b1110820dad4fe02d1f09225aede77bb709b"
                            t="7d67b1110820dad4fe02d1f09225aede77bb709b"
                            >Add Part
                        </button>
                    </div>
                    <table tsl-table [dataSource]="associatedPartsData" class="deliverables">
                        <ng-container tslColumnDef="PartNumber">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@123981d39030a859324d7229eac1c4d07f060e27"
                                t="123981d39030a859324d7229eac1c4d07f060e27"
                                >Part Number
                            </th>
                            <td tsl-cell *tslCellDef="let part"> </td>
                        </ng-container>
                        <ng-container tslColumnDef="PartDescription">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@e279e0678d78793c7d9c369e490388a8db005c37"
                                t="e279e0678d78793c7d9c369e490388a8db005c37"
                                >Part Description
                            </th>
                            <td tsl-cell *tslCellDef="let part"> </td>
                        </ng-container>
                        <ng-container tslColumnDef="Asset">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@af5ad173898168237b0ba2758143601cfae033c6"
                                t="af5ad173898168237b0ba2758143601cfae033c6"
                                >Asset#</th
                            >
                            <td tsl-cell *tslCellDef="let part"> </td>
                        </ng-container>
                        <ng-container tslColumnDef="DemandType">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@8e77424c5389ddf5df614092c37540d99bd4e314"
                                t="8e77424c5389ddf5df614092c37540d99bd4e314"
                                >Demand Type</th
                            >
                            <td tsl-cell *tslCellDef="let part"> </td>
                        </ng-container>
                        <ng-container tslColumnDef="ProcessName">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@eaed776b098725e746ebd36a4dca36c5c62d8d52"
                                t="eaed776b098725e746ebd36a4dca36c5c62d8d52"
                                >Process Name</th
                            >
                            <td tsl-cell *tslCellDef="let part"> </td>
                        </ng-container>
                        <ng-container tslColumnDef="ProcessStep">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@2b3da2c4036c7e4577dcc2e21c27d410256c1855"
                                t="2b3da2c4036c7e4577dcc2e21c27d410256c1855"
                                >Process Step</th
                            >
                            <td tsl-cell *tslCellDef="let part"> {{ part.processStepName }} </td>
                        </ng-container>
                        <ng-container tslColumnDef="AssociatedRequirement">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@f131171c36c181a6bdd3e73aac354120a24698e2"
                                t="f131171c36c181a6bdd3e73aac354120a24698e2"
                                >Associated Requirements</th
                            >
                            <td tsl-cell *tslCellDef="let part">
                                {{ part.associatedRequirements ? part.associatedRequirements.join(',') : '' }}
                            </td>
                        </ng-container>
                        <ng-container tslColumnDef="MistakePrevention">
                            <th
                                tsl-header-cell
                                *tslHeaderCellDef
                                i18n="@@987413f6effa19a941b7af888ab7ce2f9bc6dce3"
                                t="987413f6effa19a941b7af888ab7ce2f9bc6dce3"
                                >Mistake Preventions</th
                            >
                            <td tsl-cell *tslCellDef="let part">
                                {{ part.mistakePreventions ? part.mistakePreventions.join(',') : '' }}
                            </td>
                        </ng-container>
                        <tr tsl-header-row *tslHeaderRowDef="associatedPartsColumns"></tr>
                        <tr tsl-row *tslRowDef="let row; columns: associatedPartsColumns"></tr>
                        <!-- Group header -->
                        <ng-container tslColumnDef="PartNo">
                            <td tsl-cell *tslCellDef="let group">
                                <strong>{{ group.partNumber }}</strong>
                            </td>
                        </ng-container>
                        <ng-container tslColumnDef="PartDesc">
                            <td tsl-cell *tslCellDef="let group">
                                <strong>{{ group.partDescription }}</strong>
                            </td>
                        </ng-container>
                        <ng-container tslColumnDef="AssetNumber">
                            <td tsl-cell *tslCellDef="let group">
                                <strong>{{ group.assets }}</strong>
                            </td>
                        </ng-container>
                        <ng-container tslColumnDef="DemandTypeDesc">
                            <td tsl-cell *tslCellDef="let group"> {{ group.demandType }} </td>
                        </ng-container>
                        <ng-container tslColumnDef="ProcessNameGroup">
                            <td colspan="5" tsl-cell *tslCellDef="let group">
                                <strong>{{ group.caseNumber }}</strong>
                            </td>
                        </ng-container>
                        <ng-container tslColumnDef="ActionDesc">
                            <th tsl-header-cell *tslHeaderCellDef i18n="@@Action" t="Action">Action</th>
                            <td tsl-cell *tslCellDef="let group">
                                <button
                                    tsl-icon-button
                                    (click)="onRemovePart(group)"
                                    *ngIf="
                                        group.assets != null && group.assets != '' && group.isProcessFlowPart === false
                                    "
                                >
                                    <tsl-icon status="error">delete</tsl-icon>
                                </button>
                            </td>
                        </ng-container>
                        <tr
                            tsl-row
                            *tslRowDef="
                                let row;
                                columns: [
                                    'PartNo',
                                    'PartDesc',
                                    'AssetNumber',
                                    'DemandTypeDesc',
                                    'ProcessNameGroup',
                                    'ActionDesc'
                                ];
                                when: isHeader
                            "
                        >
                        </tr>
                    </table>
                </div>
            </tsl-tab>
        </tsl-tab-group>
    </div>
</ng-container>
